import httpClient from "@plugins/http";
import {
  NotificationList,
  NotificationCategory,
  UserNotificationSubscriptionModel,
  UserNotificationSubscription,
} from "@/modules/notification/types.ts";
import { ApiResponse } from "./api";

interface deleteErrorData {
  isLocked: boolean;
  user: string;
  lockedBy: string;
}

const fetchNotifications = async (params): Promise<NotificationList> => {
  return await httpClient.get(`/apis/notification/list`, { params: params });
};

const fetchDashboardNotifications = async (params): Promise<NotificationList> => {
  return await httpClient.get(`/apis/notification/dashboard/list`, { params: params });
};

const fetchManageNotifications = async (params): Promise<NotificationList> => {
  return await httpClient.get(`/apis/notification/manage/list`, { params: params });
};

const fetchUserNotificationSubscription = async (): Promise<
  ApiResponse<UserNotificationSubscriptionModel>
> => {
  return await httpClient.get(`/apis/notification/subscription`);
};

const fetchNotificationCategories = async (): Promise<ApiResponse<NotificationCategory[]>> => {
  return await httpClient.get(`/apis/notification/categories`);
};

const unreadCount = async () => {
  return await httpClient.get(`/apis/notification/poll/unread`);
};

const markAsRead = async (uuid): Promise<ApiResponse<void>> => {
  const params = new URLSearchParams();
  params.append("uuid", uuid);
  return await httpClient.post(`/apis/notification/mark/read`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const flagNotification = async (uuid) => {
  const params = new URLSearchParams();
  params.append("uuid", uuid);
  return await httpClient.post(`/apis/notification/flag`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const unflagNotification = async (uuid) => {
  const params = new URLSearchParams();
  params.append("uuid", uuid);
  return await httpClient.post(`/apis/notification/unflag`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const getNotificationDetails = async (uuid) => {
  return await httpClient.get(`/apis/notification/details/${uuid}`);
};

const toggleUserNotificationSubscription = (
  notificationSubscriptionModels: UserNotificationSubscription[],
): Promise<ApiResponse> => {
  return httpClient.post(`/apis/notification/toggle`, notificationSubscriptionModels);
};

const fetchManageNotification = async (uuid) => {
  return await httpClient.get(`/apis/notification/manage/view/${uuid}`);
};

const fetchViewerNotification = async (uuid) => {
  return await httpClient.get(`/apis/notification/view/${uuid}`);
};

const saveNotification = async (requestData): Promise<ApiResponse<void>> => {
  return await httpClient.post(`/apis/notification/save`, requestData, {
    headers: {
      "X-With-Richtext": true,
    },
  });
};

const deleteNotification = async (uuid): Promise<ApiResponse<void | deleteErrorData>> => {
  return await httpClient.post(`/apis/notification/delete/${uuid}`);
};

export default {
  fetchNotifications,
  fetchDashboardNotifications,
  fetchManageNotifications,
  fetchNotificationCategories,
  unreadCount,
  markAsRead,
  flagNotification,
  unflagNotification,
  getNotificationDetails,
  fetchUserNotificationSubscription,
  toggleUserNotificationSubscription,
  fetchManageNotification,
  fetchViewerNotification,
  saveNotification,
  deleteNotification,
};
